import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import NavigationIcon from '@material-ui/icons/Navigation';
import FolderIcon from '@material-ui/icons/Folder';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import ApartmentIcon from '@material-ui/icons/Apartment';

import {
  TextContainer,
  StyledCard,
  Title,
  LockIconContainer,
  StyledData,
} from './Card.styles';

import { createTileContent, DEFAULT_TILE_LINES } from './TileContent';
import {
  StyledTextList,
  StyledIconLine,
} from '../../views/SelectCustomerView/CustomersListy.styles';
import {
  isDelegated,
  isReadable,
  isWritable,
  isEditable,
} from '../../helpers/permissions';

const Card = ({
  id,
  tileLines,
  titleLines,
  clientDetails: { name, distance, address, clientNumber, department },
  onLinkClick,
  owned,
  access,
}) => {
  const showLockIcon = isReadable(access);
  const showLockOpenIcon =
    owned === false &&
    (isWritable(access) || isEditable(access) || isDelegated(access));
  const isClickable =
    owned || isWritable(access) || isDelegated(access) || isEditable(access);

  return (
    <Link
      to={`/customers/${id}/visit/${uuidv4()}`}
      onClick={() => {
        isClickable && onLinkClick && onLinkClick(id);
      }}
      style={{ pointerEvents: isClickable ? 'auto' : 'none' }}
    >
      <StyledCard data-testid="client-card">
        {showLockIcon && (
          <LockIconContainer data-testid="lock-icon">
            <LockOutlinedIcon />
          </LockIconContainer>
        )}
        {showLockOpenIcon && (
          <LockIconContainer data-testid="lock-icon">
            <LockOpenOutlinedIcon />
          </LockIconContainer>
        )}
        <TextContainer>
          <Title data-testid="action-title">
            <Truncate lines={titleLines} ellipsis={<span>...</span>}>
              {name}
            </Truncate>
          </Title>
          {department && (
            <StyledIconLine>
              <ApartmentIcon fontSize="small" />
              <div>
                <Truncate lines={1} ellipsis={<span>...</span>}>
                  {department}
                </Truncate>
              </div>
            </StyledIconLine>
          )}
          {address && (
            <StyledIconLine>
              <LocationOnIcon fontSize="small" />
              {createTileContent(tileLines || DEFAULT_TILE_LINES, address)}
            </StyledIconLine>
          )}
          {distance && (
            <StyledData>
              <StyledIconLine>
                <NavigationIcon fontSize="small" />
                <StyledTextList data-testid="client-distance">
                  {distance}
                </StyledTextList>
              </StyledIconLine>
            </StyledData>
          )}
          {clientNumber && (
            <StyledIconLine>
              <FolderIcon fontSize="small" />
              <div>{clientNumber}</div>
            </StyledIconLine>
          )}
        </TextContainer>
      </StyledCard>
    </Link>
  );
};

Card.propTypes = {
  id: PropTypes.string,
  tileLines: PropTypes.arrayOf(PropTypes.string),
  actionTime: PropTypes.shape({
    doAt: PropTypes.string,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
  }),
  clientDetails: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string,
    distance: PropTypes.string,
    lat: PropTypes.string,
    lng: PropTypes.string,
    department: PropTypes.string,
    generalPhoneNumber: PropTypes.string,
    classification: PropTypes.string,
    clientNumber: PropTypes.string,
  }),
  titleLines: PropTypes.number,
  owned: PropTypes.bool,
  access: PropTypes.string,
  onLinkClick: PropTypes.func,
};

export default Card;
